import { translateFn } from '../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../ui/gzDataTable/types';
import { pathValidators } from './utils/validators';

export enum ColumnKeys {
  PATH = 'path',
}

export function getTableColumns(): IDataTableColumn[] {
  return [
    {
      key: ColumnKeys.PATH,
      header: translateFn('Directories to scan'),
      columnType: IColumnType.TEXT,
      validators: pathValidators(),
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}
